import { render, staticRenderFns } from "./ModalCarrinho.vue?vue&type=template&id=b2863134&scoped=true"
import script from "./ModalCarrinho.vue?vue&type=script&lang=js"
export * from "./ModalCarrinho.vue?vue&type=script&lang=js"
import style0 from "./ModalCarrinho.vue?vue&type=style&index=0&id=b2863134&prod&lang=css"
import style1 from "./ModalCarrinho.vue?vue&type=style&index=1&id=b2863134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2863134",
  null
  
)

export default component.exports